export class ZipCodeFindPlaces {
  static readonly type = '[Zip Code] Find Places';
  constructor(public readonly payload: string) {}
}
